import React, { CSSProperties, ReactNode } from 'react';
import styles from '../styles/socialEntranceButton.module.scss';

export default function SocialEntranceButton(props: {
  children: ReactNode;
  style?: CSSProperties;
  onClick: () => void;
}) {
  return (
    <button
      style={props.style}
      className={styles.button}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}
